import { fromLocalTimeToTimezone } from '@app/booking-libs';
export function toInvocationPayload(values, props, timezone) {
    const result = {
        startDate: fromLocalTimeToTimezone(values.startDate, timezone).toISOString(),
        endDate: fromLocalTimeToTimezone(values.endDate, timezone).toISOString(),
        issuetypeId: props.issuetypeId,
        projectId: props.projectId
    };
    if (values.resource) {
        result.resourceId = values.resource;
    }
    if (values.summary) {
        result.summary = values.summary;
    }
    if (props.issueKey) {
        result.issueKey = props.issueKey;
    }
    return result;
}
export function getConfirmedStatuses(configuration) {
    return Array.from(new Set([...configuration.confirmedStatusIds, configuration.approvedStatusId])).filter((x) => x);
}
/**
 * returns true is dates are not as expected
 * @param startDate
 * @param endDate
 */
export function isStartAfterEnd({ startDate, endDate }) {
    if (!(startDate && endDate)) {
        return false;
    }
    return endDate.localeCompare(startDate) <= 0;
}
export function isStateValid(state, checkForSummary = true) {
    return ((!checkForSummary || Boolean(state.summary)) &&
        Boolean(state.startDate) &&
        Boolean(state.endDate) &&
        Boolean(state.duration) &&
        state.startDate !== state.endDate &&
        Boolean(state.resource));
}
